import React from 'react';
import { ProjectsOverview } from '@thd-olt-component-react/projects-overview';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { string } from 'prop-types';

export function Projects({ id }) {
  return (
    <ErrorBoundary name="projects">
      <QueryProvider cacheKey={`projects-cacheKey-${id}`}>
        <ProjectsOverview componentId={id} />
      </QueryProvider>
    </ErrorBoundary>
  );
}

Projects.propTypes = {
  id: string.isRequired
};
